module.exports = __webpack_public_path__ + "assets/img/13.5483fb3c.png";